import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import TextField from "@material-ui/core/TextField";

class TextEdit extends Component {
	state = {
		shortdesc: "",
		data: ""
	};

	componentDidMount() {
		this.setState({
			shortdesc: this.props.shortdesc,
			data: this.props.descripcion
		});
	}
	render() {
		return (
			<Card style={{ width: "100%", marginBottom: 10 }}>
				<CardContent>
					<Typography>
						<h3>{this.props.name}</h3>
					</Typography>
					<br />
					<TextField
							id="outlined-basic"
							label="Descripcion Corta"
							variant="outlined"
							defaultValue={this.props.shortdesc}
							style={{ width: "90%" }}
							onChange={value => this.setState({ shortdesc: value.target.value })}
					/>
					<br />
					<br />
					<br />
					<CKEditor
						editor={ClassicEditor}
						data={this.props.descripcion}
						onInit={editor => {
							// You can store the "editor" and use when it is needed.
						}}
						onChange={(event, editor) => {
							const data = editor.getData();
							console.log({ event, editor, data });

							this.setState({
								data: data
							});
						}}
						onBlur={(event, editor) => {
							console.log("Blur.", editor);
						}}
						onFocus={(event, editor) => {
							console.log("Focus.", editor);
						}}
					/>
				</CardContent>
				<CardActions>
					<Button
						onClick={() => {
							this.props.handleSaveButton(
								{
									id: this.props.id,
									name: this.props.name,
									shortdesc: this.state.shortdesc,
									descripcion: this.state.data
								},
								this.props.token
							);
						}}
					>
						Guardar
					</Button>
				</CardActions>
			</Card>
		);
	}
}
export default TextEdit;
